import { Store } from 'src/store/index';

const areAvailableFormatsLoading = (store: Store) => store.format.availableFormatsAreLoading;

export default areAvailableFormatsLoading;
